import { render, staticRenderFns } from "./MerchantPopover.vue?vue&type=template&id=206bd6bd&scoped=true&"
import script from "./MerchantPopover.vue?vue&type=script&lang=ts&"
export * from "./MerchantPopover.vue?vue&type=script&lang=ts&"
import style0 from "./MerchantPopover.vue?vue&type=style&index=0&id=206bd6bd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206bd6bd",
  null
  
)

export default component.exports